'use client';

import { Box, Stack } from '@mui/material';
import MasterLayout from '@/app/components/layout/master-layout';
import DeviceManageLayout from '@/app/components/layouts/device-manage';
import DirectContact from './direct-contact';
import DropMessage from './drop-message';

export default function ContactUsView() {
  return (
    <MasterLayout>
      <DeviceManageLayout
        title="Contact Us"
        description="Get in touch with us for inquiries, support, or feedback. We're here to help."
      >
        <Box
          sx={{
            mx: 'auto',
            width: {
              md: '100%',
              lg: '1200px',
            },
            pl: 3,
            pr: 3,
            pt: 6,
            pb: 6,
          }}
        >
          <Stack
            gap={8}
            justifyContent="space-around"
            sx={{
              flexDirection: {
                sm: 'column',
                md: 'row',
              },
            }}
          >
            <DirectContact />
            <DropMessage />
          </Stack>
        </Box>
      </DeviceManageLayout>
    </MasterLayout>
  );
}
